import service from '@/api/request';
import { defineExportApi, definePostApi } from '../utils/define';

export interface VerifyItem {
  cardList: string[];
  id: number;
  idCard: string;
  userName: string;
  oscTypeStr: string;
  reason: string;
  verifyStatus: number;
  verifyStatusStr: string;
  verifyReason: number;
  note: string;
}
export const getCertificateList = data =>
  service.post<null, Global.RecordResponse<VerifyItem>>('/api/osCard/list', data, { mock: false });

export const getCertificateCardList = data => service.post('/api/osCard/cardInfo', data, { mock: false });

export const cffeCertificateVerify = data => service.post('/api/osCard/verify', data, { mock: false });

export const getInvDrawData = data => service.post('/api/inv/getInvDrawData', data);
// 确认复赛成绩
export const confirmFinalResults = data => service.post('/api/zjs/admin/confirmFinalResults', data, { mock: false });
// 取消复赛成绩
export const cancelFinalResults = data => service.post('/api/zjs/admin/cancelFinalResults', data, { mock: false });
// 确认总奖名单
export const confirmFinalReward = data => service.post('/api/zjs/admin/confirmFinalReward', data, { mock: false });
// 取消总奖名单
export const cancelFinalReward = data => service.post('/api/zjs/admin/cancelFinalReward', data, { mock: false });
// 下载导入模版
export const downloadTemplate = (pramas: { templateType: string }) =>
  service.post<{ templateType: string }>('/api/common/downloadTemplate', pramas, {
    download: true,
    responseType: 'blob',
  });

/** 管理员-上传复赛名单 - 响应数据类型 */
export type UploadGradeListResponse = {
  code: number;
  message: string;
  success: boolean;
};

/**
 * 管理员-上传复赛名单
 * @param params 请求参数
 */
export const uploadGradeList = (
  params?: FormData // 注意：参数类型改为 FormData
) =>
  service.post<FormData, UploadGradeListResponse>('/api/zjs/admin/importFinalResult', params, {
    headers: {
      'Content-Type': 'multipart/form-data', // 新增：文件上传必须的请求头
    },
  });

/** 管理员-上传获奖名单 - 响应数据类型 */
export type UploadAwardListResponse = {
  code: number;
  message: string;
  success: boolean;
};

/**
 * 管理员-上传获奖名单
 * @param params 请求参数
 */
export const uploadAwardList = (
  params?: FormData // 注意：参数类型改为 FormData
) =>
  service.post<FormData, UploadAwardListResponse>('/api/zjs/admin/importFinalReward', params, {
    headers: {
      'Content-Type': 'multipart/form-data', // 新增：文件上传必须的请求头
    },
  });

export interface signInfoItem {
  starPhone?: string;
  province?: string;
  provinceId?: string;
  orgId?: string;
  department: string;
  stuNum: string;
  city: string;
}
// 管理员-报名信息查询
export const getAdminSignupList = data =>
  service.post<null, Global.RecordResponse<signInfoItem>>('/api/zjs/queryAdminSignInfo', data, { mock: false });
// 管理员-晋级名单查询
export const getAdminPromList = data =>
  service.post<null, Global.RecordResponse<signInfoItem>>('/api/zjs/queryAdminPromList', data, { mock: false });
// 领队-晋级名单查询
export const getTeamPromList = data =>
  service.post<null, Global.RecordResponse<signInfoItem>>('/api/zjs/queryTeamPromList', data, { mock: false });
// 管理员-复赛成绩查询
export const queryFinalResultsByPage = data =>
  service.post<null, Global.RecordResponse<signInfoItem>>('/api/zjs/admin/queryFinalResultsByPage', data, {
    mock: false,
  });
// 领队-复赛结果查询
export const queryOrgFinalRewardListByPage = data =>
  service.post<null, Global.RecordResponse<signInfoItem>>('/api/zjs/team/queryOrgFinalRewardListByPage', data, {
    mock: false,
  });

// 管理员-获奖名单查询
export const queryFinalRewardListByPage = data =>
  service.post<null, Global.RecordResponse<signInfoItem>>('/api/zjs/admin/queryFinalRewardListByPage', data, {
    mock: false,
  });
/** 导出报名信息 */
export const downloadAdminSignResults = defineExportApi('/api/zjs/downloadAdminSignInfo', 'excel');
/** 管理员导出晋级名单 */
export const downloadAdminPromList = defineExportApi('/api/zjs/downloadAdminPromList', 'excel');
/** 管理员导出复赛成绩 */
export const exportFinalResult = defineExportApi('/api/zjs/admin/exportFinalResult', 'excel');
/** 领队导出复赛成绩 */
export const exportOrgFinalReward = defineExportApi('/api/zjs/team/exportOrgFinalReward', 'excel');
/** 管理员导出获奖名单 */
export const exportFinalReward = defineExportApi('/api/zjs/admin/exportFinalReward', 'excel');
/** 领队导出晋级名单 */
export const downloadTeamPromList = defineExportApi('/api/zjs/downloadTeamPromList', 'excel');
// 获取信息详情
export const getAdminSignupDetail = data =>
  service.post<null, string>('/api/zjs/queryStuDetailInfo', data, { mock: false });
/** 管理员编辑学生信息 */
export interface EditAdminStuInfoRequest {
  department: string;
  name?: string;
  orgId: number | string;
  rid: string;
  uid?: string;
  city: string;
  province?: string;
  provinceId?: number;
  stuNum: string;
}
export const editAdminStuInfo = definePostApi<EditAdminStuInfoRequest, string>('/api/zjs/editAdminSignInfo');

// 管理员-期货模拟交易查询
export const getAdminTradeList = data =>
  service.post<null, Global.RecordResponse<any>>('/api/zjs/queryAdminFuturesInfo', data, { mock: false });
/** 导出期货模拟信息 */
export const downloadAdminTradeResults = defineExportApi('/api/zjs/downloadAdminFuturesInfo', 'excel');

// 管理员-知识答题查询
export const getAdminKnowledgeList = data =>
  service.post<null, Global.RecordResponse<any>>('/api/zjs/queryAdminFkcInfo', data, { mock: false });
/** 导出知识答题信息 */
export const downloadAdminKnowledgeResults = defineExportApi('/api/zjs/downloadAdminFkcInfo', 'excel');

// 领队-报名信息查询
export const getLeaderSignupList = data =>
  service.post<null, Global.RecordResponse<VerifyItem>>('/api/zjs/queryTeamSignInfo', data, { mock: false });
/** 导出报名信息 */
export const downloadLeaderSignResults = defineExportApi('/api/zjs/downloadTeamSignInfo', 'excel');
/** 领队编辑学生信息 */
export interface EditTeamStuInfoRequest {
  department: string;
  name?: string;
  orgId: number | string;
  rid: string;
  city: string;
  province?: string;
  provinceId?: number;
  stuNum: string;
}
export const editTeamStuInfo = definePostApi<EditTeamStuInfoRequest, string>('/api/zjs/editTeamSignInfo');

// 领队-期货模拟信息查询
export const getLeaderTradeList = data =>
  service.post<null, Global.RecordResponse<any>>('/api/zjs/queryTeamFuturesInfo', data, { mock: false });
/** 导出期货模拟信息 */
export const downloadLeaderTradeResults = defineExportApi('/api/zjs/downloadTeamFuturesInfo', 'excel');

// 领队-知识答题信息查询
export const getLeaderKnowledgeList = data =>
  service.post<null, Global.RecordResponse<any>>('/api/zjs/queryTeamFkcInfo', data, { mock: false });
/** 导出知识答题信息 */
export const downloadLeaderKnowledgeResults = defineExportApi('/api/zjs/downloadTeamFkcInfo', 'excel');

/** 领队-电子证书分页查询 */
export const getCertDigitalList = data =>
  service.post<null, Global.RecordResponse<any>>('/api/certDigital/pageList', data, { mock: false });
/** 领队-电子证书一键下载 */
export const downloadCertDigitalList = (params: { raceId: string }) =>
  service.post<{ raceId: string }>('/api/certDigital/download', params, {
    download: true,
    responseType: 'blob',
  });
/** 领队-支持赛项查询 */
export const querySupportRace = data =>
  service.post<null, Array<any>>('/api/certDigital/querySupportRace', data, { mock: false });
/** 领队-电子证书单个下载 */
export const downloadSingle = (params: { raceId: string; fileName: string }) =>
  service.post<{ raceId: string; fileName: string }>('/api/certDigital/downloadSingle', params, {
    download: true,
    responseType: 'blob',
  });
